/**
 * Serialize a value to JSON safe for embedding inside an inline <script> tag.
 * Escapes characters that would otherwise allow breaking out of the script
 * context: `<`, `>`, `&`, and the U+2028 / U+2029 line separators that JS
 * parsers treat as line terminators inside string literals.
 *
 * @param {unknown} value
 * @returns {string}
 */
const serializeForScript = (value) =>
  JSON.stringify(value ?? null)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');

export default serializeForScript;
